<style>
	.export-custom{
		width: 90%;
		margin: 0 auto;
	}
	.export-custom .el-select .el-input__inner{
		border-radius: 0;
		border-color: #ddd;
	}
	.export-custom .item-list{
		height: 350px;
		overflow: auto;
		border: 1px solid #ddd;
		border-top: none;
	}
	.export-custom .item-list-detail {
		padding: 5px 10px;
		position: relative;
	}
	.export-custom .item-list-detail .el-button{
		position: absolute;
		right: 10px;
		top: 0px;
	}
	.export-custom .item-list-detail:hover{
		background: #dddddd;
	}
	.export-custom .buttons{
		margin-top: 180px;
	}
	.export-custom .handler-row{
		border: 1px solid #ddd;
		border-top: none;
		height: 34px;
		line-height: 34px;
		padding: 0 10px;
	}
	.export-custom .buttons > button {
		margin: 20px auto;
		display: block;
	}
</style>
<template>
	<span>
    <el-dropdown>
      <el-button icon="el-icon-my-daochu" type="info">自定义导出<i class="el-icon-caret-bottom el-icon--right"></i></el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="show(false)" v-if="showChoosedButton" >导出已选记录</el-dropdown-item>
        <el-dropdown-item @click.native="show(true)">导出所有查询结果</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
		
		<el-dialog  :title="getExportTitle()" :visible.sync="showDialog" :close-on-click-modal="false">
			<div class="export-custom">
				<el-row>
					<el-col :span="10">
						<el-select v-model="exportSelected" placeholder="请选择类别" style="width: 100%;">
							<el-option v-for="(item, index) in exportList" :key="index" :value="item.value" :label="item.text"></el-option>
						</el-select>
						<div class="item-list">
							<el-checkbox-group v-model="exportItemsIds" @change="handleCheckedItemChange">
								<p class="item-list-detail" v-for="item in curExportList" @dblclick="addSingleToRight(item)" :key="item.value"><el-checkbox :label="item.value">{{item.text}}</el-checkbox></p>
							</el-checkbox-group>
						</div>
						<div class="handler-row">
							<el-checkbox v-model="checkAll" @change="handleCheckAllChange" v-show="curExportList.length">全选</el-checkbox>
						</div>
					</el-col>

					<el-col :span="4" class="buttons">
						<el-button icon="el-icon-arrow-right" @click="addToRight()"></el-button>
					</el-col>

					<el-col :span="10">
						<el-select v-model="templateSelected" placeholder="请选择模板" style="width: 100%;">
							<el-option v-for="(item, index) in templateList" :key="index" :value="item.text" :label="item.text"></el-option>
						</el-select>
						<div class="item-list">
							<el-checkbox-group v-model="curSelectedItemIds">
								<p class="item-list-detail" v-for="item in curSelectedList" :key="item.value"><el-checkbox :label="item.value">{{item.text}}</el-checkbox>
									<el-button type="text" icon="el-icon-my-shanchu" class="pull-right" style="color:#ff0000;" @click="removeSelectedItem(item)"></el-button>
								</p>
							</el-checkbox-group>
						</div>
						<div class="handler-row">
							<el-row>
								<el-col :span="19">
									<el-button size="mini" @click="removeSelectedItem()">移除</el-button>
									<el-button size="mini" @click="saveTemplate">保存模板</el-button>
									<el-button size="mini" @click="removeTemplate" v-show="templateSelected">删除当前模板</el-button>
								</el-col>
								<el-col :span="5" class="text-right">
									<span v-show="curSelectedList.length">共{{curSelectedList.length}}个</span>
								</el-col>
							</el-row>
						</div>
					</el-col>
				</el-row>
			</div>
			<div slot="footer">
				<el-button @click="submitForm()" type="primary">导出</el-button>
				<el-button @click="showDialog = false">取消</el-button>
			</div>
		</el-dialog>
	</span>
</template>

<script>
    import qs from 'qs'
    export default {
        data () {
            return {
                showDialog: false,
                checkAll: false,
                exportAll: false, // 是否查询结果全部导出
                exportList: [],
                templateList: [],
                exportSelected: '',
                templateSelected: '',
                curExportList: [],
                curSelectedList: [],
                exportItemsIds: [],
                curSelectedItemIds: []
            }
        },
        props: {
            paramsCallBack: {
                type: Function,
                default () {
                    return () => { return {} }
                }
            },
            validCallBack: {
                type: Function,
                default () {
                    return () => { return true }
                }
            },
            showChoosedButton: {
                type: Boolean,
                default: true
            }
        },
        watch: {
            exportSelected () {
                let arr = []
                if (this.exportSelected !== '') {
                    let data = this.exportList.filter(item => item.value === this.exportSelected)
                    if (data && data.length) {
                        arr = data[0].list
                    }
                    this.exportItemsIds = []
                    this.checkAll = false
                }
                this.curExportList = arr
            },
            templateSelected () {
                let arr = []
                if (this.templateSelected !== '') {
                    let data = this.templateList.filter(item => item.text === this.templateSelected)
                    if (data && data.length) {
                        arr = data[0].list
                    }
                }
                this.curSelectedList = arr
            }
        },
        methods: {
            handleCheckedItemChange (value) {
                let checkedCount = value.length
                this.checkAll = checkedCount === this.curExportList.length
            },
            handleCheckAllChange (event) {
                this.exportItemsIds = event ? this.curExportList.map(item => item.value) : []
            },
            show (exportAll) {
                if(!exportAll && !this.validCallBack()) {
                    return
                }
                this.exportSelected = ''
                this.templateSelected = ''
                this.exportAll = exportAll
                this.exportItemsIds = []
                this.curSelectedItemIds = []
                this.showDialog = true
                this.getInitData()
            },
            getInitData () {
                return this.$axios.get('/system/export/list.api').then(res => {
                    this.exportList = res.result.exportList
                    this.templateList = res.result.templateList
                })
            },
            getExportTitle() {
                return `自定义导出${this.exportAll ? '（导出全部结果）' : ''}`
            },
            addToRight () {
                if (this.exportItemsIds.length === 0) {
                    this.$message({
                        message: '请勾选字段',
                        type: 'warning'
                    })
                    return false
                }
                this.exportItemsIds.forEach(name => {
                    let data = this.curExportList.filter(item => item.value === name)
                    if (data && !this.curSelectedList.some(item => item.value === name)) {
                        this.curSelectedList.push(data[0])
                    }
                })
                this.$message('字段添加成功')
            },
            addSingleToRight (data) {
                if (data && !this.curSelectedList.some(item => item.value === data.value)) {
                    this.curSelectedList.push(data)
                }
            },
            removeSelectedItem (item) {
                let selectedIds = []
                if (item) {
                    selectedIds = [item.value]
                } else {
                    if (this.curSelectedItemIds.length === 0) {
                        this.$message({
                            message: '请勾选字段',
                            type: 'warning'
                        })
                        return false
                    }
                    Object.assign(selectedIds, this.curSelectedItemIds)
                }
                selectedIds.forEach(value => {
                    let curSelectedListIndex = this.curSelectedList.map(item => item.value).indexOf(value)
                    let curSelectedItemIdsIndex = this.curSelectedItemIds.indexOf(value)
                    curSelectedListIndex > -1 && this.curSelectedList.splice(curSelectedListIndex, 1)
                    curSelectedItemIdsIndex > -1 && this.curSelectedItemIds.splice(curSelectedItemIdsIndex, 1)
                })
            },
            saveTemplate () {
                if (this.curSelectedList.length === 0) {
                    this.$message({
                        message: '请先选择字段',
                        type: 'warning'
                    })
                    return false
                }
                this.getNameInput(this.templateSelected)
            },
            getNameInput (curName = '') {
                this.$prompt('请输入模板名称', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValue: curName,
                    inputPattern: /^[\S]{1,20}$/,
                    inputErrorMessage: '不能为空，不能空字符开头，长度不能超过20'
                }).then(({ value }) => {
                    this.$axios.post('/system/export/template.api', {
                        type: curName ? 2 : 1,
                        name: value,
                        propertyCodes: this.curSelectedList.map((item, index) => [index + 1, item.value, item.text].join(',')).join(';')
                    }).then(res => {
                        this.getInitData()
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        })
                    }).catch(() => {})
                }).catch(() => {})
            },
            removeTemplate () {
                if (this.templateSelected !== '') {
                    this.$confirm('是否删除“' + this.templateSelected + '”?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$axios.post('/system/export/template.api', {
                            type: 3,
                            name: this.templateSelected
                        }).then(res => {
                            this.getInitData()
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            })
                            this.templateSelected = ''
                        })
                    }).catch(() => {})
                } else {
                    this.$message({
                        message: '请选择模板',
                        type: 'warning'
                    })
                }
            },
            submitForm (ids) {
                if (this.curSelectedList.length === 0) {
                    this.$message({
                        message: '请选择需要导出的字段',
                        type: 'warning'
                    })
                    return false
                }
                let phaseMap = {
                    resume: '0',
                    written: '1',
                    interview: '2',
                    salary: '3',
                    enry: '4'
                }
                let path = this.$route.path,
                    phase = ''
                Object.keys(phaseMap).map(cv => {
                    if(path.indexOf(cv) > -1) {
                        phase = phaseMap[cv] 
                    }
                })
                let paramsStr = qs.stringify(this.paramsCallBack(phase, this.exportAll))
                let propertyCodes = this.curSelectedList.map((item, index) => [index + 1, item.value, item.text].join(',')).join(';')
                window.open(`${this.$axios.defaults.baseURL}/system/export/exportExcel.api?propertyCodes=${propertyCodes}&${paramsStr}`)
                console.log(`${this.$axios.defaults.baseURL}/system/export/exportExcel.api?propertyCodes=${propertyCodes}&${paramsStr}`)
                this.showDialog = false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// exportCustomDialog.vue?1d56b068